import { Guid } from 'guid-typescript'
import { campoDeveSerMaiorQueZero, campoObrigatorio } from 'helpers/Constantes/Mensagens'

export type Custo = {
  descricao: string
  valor: string | number
}

export const dadosCustoValorDefault = {
  descricao: '',
  valor: ''
} as Custo

export type DadosUrbanizacao = {
  itensUrbanizacao: Custo[]
  valorTotal: string | number
  valido: boolean
  id: Guid
}

export const dadosUrbanizacaoValorDefault = {
  valorTotal: '',
  itensUrbanizacao: [{ ...dadosCustoValorDefault }],
  valido: true,
  id: Guid.createEmpty()
} as DadosUrbanizacao

export class ValidacaoDadosUrbanizacao {
  itensUrbanizacao: Custo[]

  constructor(itensUrbanizacao: Custo[] = [{ ...dadosCustoValorDefault }]) {
    this.itensUrbanizacao = itensUrbanizacao
  }

  validarDescricao(descricao: string): string {
    let error = ''

    if (descricao === '') error = campoObrigatorio

    return error
  }

  validarValor(valor: string): string {
    let error = ''

    if (valor === '') error = campoObrigatorio
    if (parseFloat(valor) === 0) error = campoDeveSerMaiorQueZero

    return error
  }

  validarTodosCampos(state: DadosUrbanizacao): boolean {
    let isValido = true
    state.itensUrbanizacao.forEach((itemUrbanizacao) => {
      if (itemUrbanizacao.descricao === '' && itemUrbanizacao.valor === '') {
        isValido = true
      } else if (this.validarDescricao(itemUrbanizacao.descricao) != '' || this.validarValor(itemUrbanizacao.valor.toString()) != '') {
        isValido = false
      }
    })
    return isValido
  }
}
